(() => {
  function init(root = document) {
    root.querySelectorAll('[data-cami-zone]').forEach(select => {
      if (select.dataset.ready) return;
      select.dataset.ready = 'true';
      const container = select.closest('.cami-delivery');
      const result = container.querySelector('[data-zone-result]');
      const copyElement = document.querySelector('[data-cami-delivery-copy]');
      if (!copyElement) return;
      const copy = JSON.parse(copyElement.textContent);
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.cartUpdate, event => {
          if (Number.isFinite(event.cartData?.total_price)) {
            select.dataset.total = String(event.cartData.total_price);
            if (select.value) select.dispatchEvent(new Event('change'));
          }
        });
      }
      select.addEventListener('change', () => {
        const zone = select.value;
        result.textContent = '';
        if (!zone) return;
        if (zone === 'other_rm') { result.textContent = copy.other; return; }
        const parts = new Intl.DateTimeFormat('en-US', { timeZone: 'America/Santiago', weekday: 'short', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }).formatToParts(new Date());
        const get = type => parts.find(part => part.type === type).value;
        const day = get('weekday');
        const minutes = Number(get('hour')) * 60 + Number(get('minute'));
        const beforeCutoff = day !== 'Sun' && minutes < (day === 'Sat' ? 780 : 900);
        const regional = zone === 'regions';
        const threshold = regional ? 4999000 : 1999000;
        const total = Number(select.dataset.total);
        const tariff = regional ? '$4.990' : '$3.990';
        const thresholdText = regional ? '$49.990' : '$19.990';
        const schedule = regional ? copy.regions : (beforeCutoff ? copy.today : copy.next);
        const delivery = total >= threshold ? copy.free : copy.rate.replace('[rate]', tariff).replace('[threshold]', thresholdText);
        result.textContent = schedule + ' ' + delivery;
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
